import {connect} from 'react-redux'
import {onChangeDetailsUI} from '../details/details.action'
import {activateLeg, addLeg, moveLegs, resizeLegs, deleteLeg} from './leg.action'
import {LegGrid} from '../leg_grid/leggrid.component'
import {setCommitMsg} from '../socket/socket.action'

import deeplinksUtil from '../util/deeplinks.util'
import userUtil from '../util/user.util'


const mapStateToProps = (state) => {
    const COLUMNS_PER_DAY = 4
    const count = state.getIn(['document', 'properties', 'totalDays'])

    return {
        legs: state.getIn(['document', 'legs']),
        activeLeg: state.getIn(['uiState', 'activeLeg']),
        columns: count * COLUMNS_PER_DAY,
        columnsPerDay: COLUMNS_PER_DAY,
        presence: state.getIn(['socket', 'presence']),
        currentUser: userUtil.getCurrentUser(state),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onActivateLeg: (leg) => {
            let deepLinkData = {
                'leg': leg,
                'section': 'DESTINATION',
                'subsection': 'OVERVIEW',
                'subdetail': ''
            }
            deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData)
            dispatch(onChangeDetailsUI('DESTINATION', 'OVERVIEW', ''))
            dispatch(activateLeg(leg))
        },
        onAddLeg: () => {
            dispatch(setCommitMsg('Added new leg'))
            dispatch(addLeg())
        },
        onMoveLegs: (legs) => {
            dispatch(setCommitMsg('Moved legs'))
            dispatch(moveLegs(legs))
        },
        onResizeLegs: (legs) => {
            dispatch(setCommitMsg('Resized legs'))
            dispatch(resizeLegs(legs))
        },
        onDeleteLeg: (leg) => {
            // if(confirm('Are you sure you want to delete this destination?')){
            dispatch(deleteLeg(leg))
            // }
        },
    }
}

const LegContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LegGrid)

export default LegContainer
